export default __webpack_public_path__ + "static/media/V470_RoHS.36747959.pdf";